import request from '../request.js'

// 查询岗位列表（郑勇）
const selectAll = function (data) {
    return request({
        url: 'sysPosition/selectAll',
        method: 'post',
        data
    })
}

// 编辑或者保存 岗位（郑勇）
const saveOrUpdate = function (data) {
    return request({
        url: 'sysPosition/saveOrUpdate',
        method: 'post',
        data
    })
}

// 根据ID 删除岗位（郑勇）
const deleteById = function (data) {
    return request({
        url: 'sysPosition/delete',
        method: 'post',
        data
    })
}

// 根据ID 查询菜单（郑勇）
const selectMenusById = function (data) {
    return request({
        url: 'sysPosition/selectMenusById',
        method: 'post',
        data
    })
}

// 保存岗位与菜单关联关系（郑勇）
const savePositionAndMenu = function (data) {
    return request({
        url: 'sysPosition/savePositionAndMenu',
        method: 'post',
        data
    })
}

// 通过菜单ID 查询按钮数组（郑勇）
const selectBtnsByMenuId = function (data) {
    return request({
        url: 'sysPosition/selectBtnsByMenuId',
        method: 'post',
        data
    })
}

// 保存菜单与按钮 关联关系（郑勇）
const saveMenuAndBtn = function (data) {
    return request({
        url: 'sysPosition/saveMenuAndBtn',
        method: 'post',
        data
    })
}

export {
    selectAll,
    saveOrUpdate,
    deleteById,
    selectMenusById,
    savePositionAndMenu,
    selectBtnsByMenuId,
    saveMenuAndBtn,

}